import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, viewChild, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DonchianService } from 'src/app/services/donchian.service';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { TradingSystemGraficoWeeklyComponent } from "../../shared/trading-system-grafico-weekly/trading-system-grafico-weekly.component";
import { TradingSystemReportComponent } from '../../shared/trading-system-report/trading-system-report.component';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { FiltriDonchianComponent } from "../../shared/filtri-donchian/filtri-donchian.component";

@Component({
  selector: 'app-ultimi-m15',
  standalone: true,
  imports: [CommonModule, HighchartsChartModule, ReactiveFormsModule,
    TradingSystemReportComponent, MdbFormsModule, MdbSelectModule, FiltriDonchianComponent],
  templateUrl: './ultimi-m15.component.html',
  styleUrl: './ultimi-m15.component.scss',
  providers: [MdbModalService]
})
export class DonchianUltimiM15Component implements OnInit, OnDestroy {
  tradingSystemSummary!: TradingSystemSummary
  subServ: Subscription = new Subscription()
  markets: any[] = []
  vediChart: boolean = false
  crossTrend: boolean = true
  mediaAttuale: number = 50
  donchianAttuale: number = 10
  takeprofitAttuale: number = 0.9
  daAnnoAttuale: number = 2021
  volumeVariabile: boolean = false
  filtrati: boolean = false

  listaDatiCompleta: any[] = []
  listaDatiFiltrati: any[] = []

  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  chartOptions: Highcharts.Options = {}
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false


  mktSelezionato: string = ''
  loading: boolean = false

  @ViewChild('report') report: TradingSystemReportComponent = new TradingSystemReportComponent(this.modalService)
  @ViewChild(FiltriDonchianComponent) filtriDonchianComponent!: FiltriDonchianComponent;

  constructor(private serv: DonchianService,
    private modalService: MdbModalService
  ) { }


  ngOnInit(): void {
    this.serv.getMarkets().subscribe((data: any) => {
      if (data.res == 'ok') {
        this.markets = data.data
      }
    })
  }

  ngOnDestroy(): void {
    this.subServ.unsubscribe()
  }

  selMarket(mkt: string) {
    this.loading = true
    this.mktSelezionato = mkt
    let m = this.markets.find((el: any) => el.market == mkt)
    let filtri = this.filtriDonchianComponent.formFiltri.value
    console.log(filtri)
    let forex = (m.tipo == 'Major' || m.tipo == 'Cross')
    this.filtriDonchianComponent.resetFiltri(forex)
    this.subServ = this.serv.ultimiM15(mkt, forex).subscribe(
      (data: any) => {
        console.log(data)
        if (data.res == 'ok') {
          this.vediChart = true
          this.report.caricaDati(m, 'm15', data.data)
          this.listaDatiCompleta = data.data
        }
        this.loading = false
      }
    )
  }

  graficoBT(mkt: string, s1: any, s2: any) {
    let ser: Highcharts.SeriesOptionsType[] = [
      { name: 'Close', type: 'line', data: s1, color: 'lightgreen', turboThreshold: 2000 },
      { name: 'Progressivo', type: 'line', data: s2, color: 'aqua', turboThreshold: 2000, yAxis: 2 },
    ]
    this.chartOptions = {
      title: { text: mkt + ' M15' },
      chart: {
        zooming: {
          type: 'x'
        },
      },
      series: ser,
      yAxis: [
        {
          plotLines: [{
            value: 0,
            width: 2,
            color: 'black',
            zIndex: 4
          }],
        },
        {
          title: { text: mkt }
        },
        {
          title: { text: 'Progressivo' },
          opposite: true
        },
      ]
    }
  }

  filtra(params: any) {
    this.loading = true
    console.log(params)
    let media = params.media
    let donchian = params.donchian
    if (media != this.mediaAttuale || donchian != this.donchianAttuale ||
      params.takeprofit != this.takeprofitAttuale || params.daAnno != this.daAnnoAttuale ||
      this.crossTrend != params.fotsi2) {
      this.crossTrend = params.fotsi2
      this.mediaAttuale = media
      this.donchianAttuale = donchian
      this.takeprofitAttuale = params.takeprofit
      this.daAnnoAttuale = params.daAnno
      this.serv.ultimiM15(this.mktSelezionato, this.crossTrend, params.daAnno, media, donchian, params.takeprofit).subscribe((data: any) => {
        console.log(data)
        if (data.res == 'ok') {
          this.vediChart = true
          let m = this.markets.find((el: any) => el.market == this.mktSelezionato)
          this.report.caricaDati(m, 'm15', data.data)
          this.listaDatiCompleta = data.data
        }
        this.loading = false
      })
    } else {

      this.loading = false
    }
  }

  filtra2(params: any) {
    if (params.media != this.mediaAttuale || params.donchian != this.donchianAttuale ||
      params.takeprofit != this.takeprofitAttuale) {
      return
    }
    if (!this.mktSelezionato) return
    this.loading = true
    this.filtrati = true
    // applica i filtri a this.listaDatiCompleta
    // e aggiorna this.report con i dati filtrati
    let datiFiltrati = this.listaDatiCompleta.filter((entry: any) => {
      // filtro giorni della settimana
      let giornoOk = false
      let giornoSettimana = new Date(entry.ora).getDay() // 0=Dom,1=Lun,...6=Sab
      if (giornoSettimana == 0 && params.weekday.dom) giornoOk = true
      if (giornoSettimana == 1 && params.weekday.lun) giornoOk = true
      if (giornoSettimana == 2 && params.weekday.mar) giornoOk = true
      if (giornoSettimana == 3 && params.weekday.mer) giornoOk = true
      if (giornoSettimana == 4 && params.weekday.gio) giornoOk = true
      if (giornoSettimana == 5 && params.weekday.ven) giornoOk = true
      if (giornoSettimana == 6 && params.weekday.sab) giornoOk = true
      if (!giornoOk) return false

      if (entry.verso == 'buy') {
        // filtro giorni della settimana buy
        let giornoOk = false
        if (giornoSettimana == 0 && params.weekdayBuy.dom) giornoOk = true
        if (giornoSettimana == 1 && params.weekdayBuy.lun) giornoOk = true
        if (giornoSettimana == 2 && params.weekdayBuy.mar) giornoOk = true
        if (giornoSettimana == 3 && params.weekdayBuy.mer) giornoOk = true
        if (giornoSettimana == 4 && params.weekdayBuy.gio) giornoOk = true
        if (giornoSettimana == 5 && params.weekdayBuy.ven) giornoOk = true
        if (giornoSettimana == 6 && params.weekdayBuy.sab) giornoOk = true
        if (!giornoOk) return false
      }
      if (entry.verso == 'sell') {
        // filtro giorni della settimana sell
        let giornoOk = false
        if (giornoSettimana == 0 && params.weekdaySell.dom) giornoOk = true
        if (giornoSettimana == 1 && params.weekdaySell.lun) giornoOk = true
        if (giornoSettimana == 2 && params.weekdaySell.mar) giornoOk = true
        if (giornoSettimana == 3 && params.weekdaySell.mer) giornoOk = true
        if (giornoSettimana == 4 && params.weekdaySell.gio) giornoOk = true
        if (giornoSettimana == 5 && params.weekdaySell.ven) giornoOk = true
        if (giornoSettimana == 6 && params.weekdaySell.sab) giornoOk = true
        if (!giornoOk) return false
      }

      // filtro mesi
      let meseOk = false
      let mese = new Date(entry.ora).getMonth() // 0=Gen,...11=Dic
      if (mese == 0 && params.mesi.gen) meseOk = true
      if (mese == 1 && params.mesi.feb) meseOk = true
      if (mese == 2 && params.mesi.marzo) meseOk = true
      if (mese == 3 && params.mesi.apr) meseOk = true
      if (mese == 4 && params.mesi.mag) meseOk = true
      if (mese == 5 && params.mesi.giu) meseOk = true
      if (mese == 6 && params.mesi.lug) meseOk = true
      if (mese == 7 && params.mesi.ago) meseOk = true
      if (mese == 8 && params.mesi.set) meseOk = true
      if (mese == 9 && params.mesi.ott) meseOk = true
      if (mese == 10 && params.mesi.nov) meseOk = true
      if (mese == 11 && params.mesi.dic) meseOk = true
      if (!meseOk) return false
      if (entry.verso == 'buy') {
        // filtro mesi buy
        let meseOk = false
        if (mese == 0 && params.mesiBuy.gen) meseOk = true
        if (mese == 1 && params.mesiBuy.feb) meseOk = true
        if (mese == 2 && params.mesiBuy.marzo) meseOk = true
        if (mese == 3 && params.mesiBuy.apr) meseOk = true
        if (mese == 4 && params.mesiBuy.mag) meseOk = true
        if (mese == 5 && params.mesiBuy.giu) meseOk = true
        if (mese == 6 && params.mesiBuy.lug) meseOk = true
        if (mese == 7 && params.mesiBuy.ago) meseOk = true
        if (mese == 8 && params.mesiBuy.set) meseOk = true
        if (mese == 9 && params.mesiBuy.ott) meseOk = true
        if (mese == 10 && params.mesiBuy.nov) meseOk = true
        if (mese == 11 && params.mesiBuy.dic) meseOk = true
        if (!meseOk) return false
      }
      if (entry.verso == 'sell') {
        // filtro mesi sell
        let meseOk = false
        if (mese == 0 && params.mesiSell.gen) meseOk = true
        if (mese == 1 && params.mesiSell.feb) meseOk = true
        if (mese == 2 && params.mesiSell.marzo) meseOk = true
        if (mese == 3 && params.mesiSell.apr) meseOk = true
        if (mese == 4 && params.mesiSell.mag) meseOk = true
        if (mese == 5 && params.mesiSell.giu) meseOk = true
        if (mese == 6 && params.mesiSell.lug) meseOk = true
        if (mese == 7 && params.mesiSell.ago) meseOk = true
        if (mese == 8 && params.mesiSell.set) meseOk = true
        if (mese == 9 && params.mesiSell.ott) meseOk = true
        if (mese == 10 && params.mesiSell.nov) meseOk = true
        if (mese == 11 && params.mesiSell.dic) meseOk = true
        if (!meseOk) return false
      }
      // filtro orari
      let oraOk = false
      let ora = new Date(entry.ora).getHours() // 0-23
      if (ora == 0 && params.orari.ora0) oraOk = true
      if (ora == 1 && params.orari.ora1) oraOk = true
      if (ora == 2 && params.orari.ora2) oraOk = true
      if (ora == 3 && params.orari.ora3) oraOk = true
      if (ora == 4 && params.orari.ora4) oraOk = true
      if (ora == 5 && params.orari.ora5) oraOk = true
      if (ora == 6 && params.orari.ora6) oraOk = true
      if (ora == 7 && params.orari.ora7) oraOk = true
      if (ora == 8 && params.orari.ora8) oraOk = true
      if (ora == 9 && params.orari.ora9) oraOk = true
      if (ora == 10 && params.orari.ora10) oraOk = true
      if (ora == 11 && params.orari.ora11) oraOk = true
      if (ora == 12 && params.orari.ora12) oraOk = true
      if (ora == 13 && params.orari.ora13) oraOk = true
      if (ora == 14 && params.orari.ora14) oraOk = true
      if (ora == 15 && params.orari.ora15) oraOk = true
      if (ora == 16 && params.orari.ora16) oraOk = true
      if (ora == 17 && params.orari.ora17) oraOk = true
      if (ora == 18 && params.orari.ora18) oraOk = true
      if (ora == 19 && params.orari.ora19) oraOk = true
      if (ora == 20 && params.orari.ora20) oraOk = true
      if (ora == 21 && params.orari.ora21) oraOk = true
      if (ora == 22 && params.orari.ora22) oraOk = true
      if (ora == 23 && params.orari.ora23) oraOk = true
      if (!oraOk) return false
      if (entry.verso == 'buy') {
        // filtro orari buy
        let oraOk = false
        if (ora == 0 && params.orariBuy.ora0) oraOk = true
        if (ora == 1 && params.orariBuy.ora1) oraOk = true
        if (ora == 2 && params.orariBuy.ora2) oraOk = true
        if (ora == 3 && params.orariBuy.ora3) oraOk = true
        if (ora == 4 && params.orariBuy.ora4) oraOk = true
        if (ora == 5 && params.orariBuy.ora5) oraOk = true
        if (ora == 6 && params.orariBuy.ora6) oraOk = true
        if (ora == 7 && params.orariBuy.ora7) oraOk = true
        if (ora == 8 && params.orariBuy.ora8) oraOk = true
        if (ora == 9 && params.orariBuy.ora9) oraOk = true
        if (ora == 10 && params.orariBuy.ora10) oraOk = true
        if (ora == 11 && params.orariBuy.ora11) oraOk = true
        if (ora == 12 && params.orariBuy.ora12) oraOk = true
        if (ora == 13 && params.orariBuy.ora13) oraOk = true
        if (ora == 14 && params.orariBuy.ora14) oraOk = true
        if (ora == 15 && params.orariBuy.ora15) oraOk = true
        if (ora == 16 && params.orariBuy.ora16) oraOk = true
        if (ora == 17 && params.orariBuy.ora17) oraOk = true
        if (ora == 18 && params.orariBuy.ora18) oraOk = true
        if (ora == 19 && params.orariBuy.ora19) oraOk = true
        if (ora == 20 && params.orariBuy.ora20) oraOk = true
        if (ora == 21 && params.orariBuy.ora21) oraOk = true
        if (ora == 22 && params.orariBuy.ora22) oraOk = true
        if (ora == 23 && params.orariBuy.ora23) oraOk = true
        if (!oraOk) return false
      }
      if (entry.verso == 'sell') {
        // filtro orari sell
        let oraOk = false
        if (ora == 0 && params.orariSell.ora0) oraOk = true
        if (ora == 1 && params.orariSell.ora1) oraOk = true
        if (ora == 2 && params.orariSell.ora2) oraOk = true
        if (ora == 3 && params.orariSell.ora3) oraOk = true
        if (ora == 4 && params.orariSell.ora4) oraOk = true
        if (ora == 5 && params.orariSell.ora5) oraOk = true
        if (ora == 6 && params.orariSell.ora6) oraOk = true
        if (ora == 7 && params.orariSell.ora7) oraOk = true
        if (ora == 8 && params.orariSell.ora8) oraOk = true
        if (ora == 9 && params.orariSell.ora9) oraOk = true
        if (ora == 10 && params.orariSell.ora10) oraOk = true
        if (ora == 11 && params.orariSell.ora11) oraOk = true
        if (ora == 12 && params.orariSell.ora12) oraOk = true
        if (ora == 13 && params.orariSell.ora13) oraOk = true
        if (ora == 14 && params.orariSell.ora14) oraOk = true
        if (ora == 15 && params.orariSell.ora15) oraOk = true
        if (ora == 16 && params.orariSell.ora16) oraOk = true
        if (ora == 17 && params.orariSell.ora17) oraOk = true
        if (ora == 18 && params.orariSell.ora18) oraOk = true
        if (ora == 19 && params.orariSell.ora19) oraOk = true
        if (ora == 20 && params.orariSell.ora20) oraOk = true
        if (ora == 21 && params.orariSell.ora21) oraOk = true
        if (ora == 22 && params.orariSell.ora22) oraOk = true
        if (ora == 23 && params.orariSell.ora23) oraOk = true
        if (!oraOk) return false
      }

      return true
    })
    if (this.volumeVariabile) {
      this.calcolaVolumeVariabile(datiFiltrati)
      this.loading = false
      return
    }
    this.listaDatiFiltrati = datiFiltrati
    this.report.caricaDati(this.markets.find((el: any) => el.market == this.mktSelezionato), 'm15', datiFiltrati)
    this.loading = false
  }

  impostaVolumeVariabile(imposta: boolean) {
    this.volumeVariabile = imposta
    if (imposta) {
      if (this.filtrati) {
        this.calcolaVolumeVariabile(this.listaDatiFiltrati)
      } else {
        this.calcolaVolumeVariabile(this.listaDatiCompleta)
      }
    } else {
      if(this.filtrati) {
        this.report.caricaDati(this.markets.find((el: any) => el.market == this.mktSelezionato), 'm15', this.listaDatiFiltrati)
        return
      }
      this.report.caricaDati(this.markets.find((el: any) => el.market == this.mktSelezionato), 'm15', this.listaDatiCompleta)
    }
  }

  calcolaVolumeVariabile(listaValori: any[]) {
    if (!this.volumeVariabile) return
    let sum_hilo = listaValori.map(el => el.hilo).reduce((a: number, b: number) => a + b, 0)
    let vol_medio = sum_hilo / listaValori.length
    let arrCopy = listaValori.map((el: any) => ({ ...el }))
    let prog = 0
    arrCopy.forEach((el: any) => {
      el.profit = el.profit * (vol_medio / el.hilo)
      prog += el.profit
      el.prog = prog
      el.totale = prog
    })
    this.report.caricaDati(this.markets.find((el: any) => el.market == this.mktSelezionato), 'm15', arrCopy)
  }

}